<template>
    <main
        class="login-main bg-white dark:bg-slate-900 overflow-hidden md:min-h-screen md:flex"
        :class="{
            'is-register': isRegister,
            'is-auth-white': isRegister || isLogin,
        }"
    >
        <div class="w-full mx-auto auth-container">
            <!-- removed max-w-[1440px] -->
            <div class="relative md:flex md:min-h-screen justify-between">
                <div class="md:w-1/2 relative z-20 bg-white dark:bg-slate-900">
                    <div
                        class="min-h-screen md:min-h-screen flex flex-col justify-start md:justify-center px-0 py-0 md:px-4 md:py-8"
                    >
                        <div
                            class="w-full max-w-sm mx-auto px-6 md:px-0 py-8 md:py-0"
                            :class="
                                isLogin && !showLoginFormOnMobile
                                    ? 'hidden md:block'
                                    : ''
                            "
                        >
                            <div
                                v-if="
                                    (isLogin && showLoginFormOnMobile) ||
                                    !isLogin
                                "
                                class="md:hidden w-full flex justify-center pt-2 pb-12"
                            >
                                <img
                                    src="/images/logo.svg"
                                    alt="My10x"
                                    class="h-6"
                                />
                            </div>
                            <div
                                class="hidden md:flex w-full justify-center pt-2 pb-8"
                            >
                                <img
                                    src="/images/logo.svg"
                                    alt="My10x"
                                    class="h-6"
                                />
                            </div>
                            <slot />
                        </div>
                        <div
                            v-if="isLogin && !showLoginFormOnMobile"
                            ref="mobileBlockRef"
                            class="md:hidden mt-0 md:mt-8 relative bg-white dark:bg-slate-900"
                            style="max-height: 1024px"
                        >
                            <div
                                class="absolute inset-x-0 top-0 overflow-hidden pointer-events-none select-none z-0"
                                :style="{
                                    height: mobileVectorH + 'px',
                                    maxHeight: '1024px',
                                }"
                            >
                                <img
                                    src="/images/register-slider/Vector.png"
                                    alt=""
                                    aria-hidden="true"
                                    class="relative w-full h-auto top-[-30px] vector-bg"
                                />
                                <div
                                    class="absolute inset-x-0 bottom-0 h-16 bg-gradient-to-b from-transparent to-white dark:to-slate-900"
                                ></div>
                            </div>
                            <div class="relative z-10">
                                <div
                                    class="w-full flex justify-center pt-6 pb-12"
                                >
                                    <img
                                        src="/images/logo.svg"
                                        alt="My10x"
                                        class="h-6"
                                    />
                                </div>
                                <AuthPromoSlider />
                            </div>
                        </div>
                    </div>
                </div>

                <div
                    class="hidden md:flex md:w-[47%] relative z-10 bg-white px-12 register-slider-pane items-start pt-8 md:self-start"
                >
                    <img
                        src="/images/register-slider/Vector.png"
                        alt=""
                        aria-hidden="true"
                        class="absolute inset-0 w-full h-full object-cover pointer-events-none select-none z-0 vector-bg"
                    />
                    <div
                        class="pane-inner relative z-10 w-full mx-auto pb-6 md:px-0"
                    >
                        <AuthPromoSlider />
                    </div>
                </div>
            </div>
        </div>
        <AppNotifications />
    </main>
</template>
<script setup>
// import LoginCards from '@/components/login-cards.vue'; // no longer used
import AuthPromoSlider from '@/components/auth/AuthPromoSlider.vue';
import AppNotifications from '@/components/app-notifications.vue';
import { onMounted, onBeforeUnmount, computed, ref } from 'vue';
import { usePage } from '@inertiajs/vue3';
import { setItem } from '@/utils/localStorage';

const page = usePage();
const isRegister = computed(() => {
    const comp = String(page?.component || '');
    const url = String(page?.url || '');
    if (comp === 'Auth/Register' || /(?:^|\/)register(?:\/|$)/.test(url)) {
        return true;
    }
    return false;
});

const isLogin = computed(() => {
    const comp = String(page?.component || '');
    const url = String(page?.url || '');
    if (comp === 'Auth/Login' || /(?:^|\/)login(?:\/|$)/.test(url)) {
        return true;
    }
    return false;
});

const showRegisterFormOnMobile = computed(() => {
    try {
        const url = String(page?.url || '');
        const q = url.includes('?') ? url.split('?')[1] : '';
        const params = new URLSearchParams(q);
        return params.get('form') === '1';
    } catch (_) {
        return false;
    }
});

const showLoginFormOnMobile = computed(() => {
    try {
        const url = String(page?.url || '');
        const q = url.includes('?') ? url.split('?')[1] : '';
        const params = new URLSearchParams(q);
        return params.get('form') === '1';
    } catch (_) {
        return false;
    }
});

const mobileVectorH = ref(540);
const mobileBlockRef = ref(null);
function handleMobileFigureHeight(ev) {
    mobileVectorH.value = 540;
}

onMounted(() => {
    setItem('asset_version', page.props.asset_version);
    try {
        window.addEventListener(
            'mobile-slider-figure-height',
            handleMobileFigureHeight
        );
    } catch (_) {}
});

onBeforeUnmount(() => {
    try {
        window.removeEventListener(
            'mobile-slider-figure-height',
            handleMobileFigureHeight
        );
    } catch (_) {}
});
</script>

<style>
/* Make the auth page background white on Register (disable blue bg image/color) */
.login-main.is-register {
    background-image: none !important;
    background-color: #ffffff !important;
}

/* Also white background for Login (and Register) using a generic flag */
.login-main.is-auth-white {
    background-image: none !important;
    background-color: #ffffff !important;
}
/* Right pane: always fill full viewport height */
.register-slider-pane {
    height: 100dvh;
    max-height: none;
    overflow: hidden;
}

.register-slider-pane .pane-inner {
    height: 100%;
    max-height: 100%;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

/* Vector background opacity - reduce by 20% with cross-browser support */
.vector-bg {
    opacity: 0.8;
    -ms-filter: 'progid:DXImageTransform.Microsoft.Alpha(Opacity=80)';
    filter: alpha(opacity=80);
}
</style>
